import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const TextLink = ({ to, children, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="group inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.28em] text-[#111111] border-b border-[#111111]/30 pb-1.5 hover:border-[#111111] transition-colors duration-500"
  >
    {children}
    <ArrowRight className="w-3.5 h-3.5 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.25} />
  </Link>
);
